<template>
  <Team_post_investment_operation_bar_en_m></Team_post_investment_operation_bar_en_m>
  <router-view></router-view>
</template>

<script>
import Team_post_investment_operation_bar_en_m
  from "@/components/EN_mobile/team/Team_post_investment_operation_bar_en_m";
export default {
  name: 'Team_post_investment_operation_en_m',
  components: {Team_post_investment_operation_bar_en_m, },
}

</script>

<style scoped>

</style>